import { UserProfileInput } from '../../../graphql.generated';
import {
    checkIsGoalValue,
    checkIsSituationValue,
    checkIsValidMortgageValue,
    AnswerData,
    QuestionNames
} from '../../your-situation/your-situation.types';

export const checkResponseType = (data: AnswerData): UserProfileInput => {
    if (
        data['situationWhatIsYourCurrentPropertyGoal'] &&
        !checkIsGoalValue(data['situationWhatIsYourCurrentPropertyGoal'])
    ) {
        throw new Error('Invalid property goal value.');
    }

    if (
        data['situationWhenDoesYourCurrentMortgageRateExpire'] &&
        !checkIsValidMortgageValue(
            data['situationWhenDoesYourCurrentMortgageRateExpire']
        )
    ) {
        throw new Error('Invalid remortgage answer.');
    }

    const allYesAndNoQuestions = Object.keys(data).filter(
        (item) =>
            item !== 'situationWhatIsYourCurrentPropertyGoal' &&
            item !== 'situationWhenDoesYourCurrentMortgageRateExpire'
    );

    for (const val in allYesAndNoQuestions) {
        const key = allYesAndNoQuestions[val];
        const value = data?.[key as QuestionNames];
        if (value && !checkIsSituationValue(value)) {
            throw new Error('Invalid situation question value.');
        }
    }

    return {
        ...data
    };
};
